import ControlButton from './ControlButton';

function DoneButton({ onClick }: { onClick: () => void }) {
  return (
    <div>
      <ControlButton variant="success" className="w-full flex-col h-auto py-2" onClick={onClick} aria-label="Reset timer">
        <div className="text-2xl">Well done!</div>
        <div className="">Click to reset</div>
      </ControlButton>
    </div>
  );
}

export default DoneButton;
